export default function QueenRaceRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                `}
            </style>
            {show && (
                <div className="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Queen Race</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To predict the Player/Position that will get a total (Card value plus place value) greater than or equal to 10</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b>Bets:</b>Result = Sum of Number Dealt on Card and the Player/Position it is dealt</p>
                                            <p class="pt20"><b>Example:</b></p>
                                            <div>
                                                <div>
                                                    <div>
                                                        <p class="pt20">As per the bet placed. </p>
                                                        <table class="table table-bordered table-sm">
                                                            <tbody>
                                                                <tr>
                                                                    <th>Position</th>
                                                                    <th>0</th>
                                                                    <th>1</th>
                                                                    <th>2</th>
                                                                    <th>3</th>
                                                                </tr>
                                                                <tr>
                                                                    <th>Card Dealt</th>
                                                                    <th>4 Diamond</th>
                                                                    <th>Q Heart</th>
                                                                    <th>6 Club</th>
                                                                    <th>5 Spade</th>
                                                                </tr>
                                                                <tr>
                                                                    <th>Result</th>
                                                                    <th>4</th>
                                                                    <th>13</th>
                                                                    <th>8</th>
                                                                    <th>8</th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <p class="pt20">The Player/Position with the highest Result is declared winner.</p>
                                            <p class="pt20"><b>Cards: 2 to 6 of all suits and one Q Spade.</b></p>
                                            <p class="pt20">Number Ranking:</p>
                                            <ul style={{ textAlign: "left" }}>
                                                <li>2 = 2 point</li>
                                                <li>3 = 3 Point</li>
                                                <li>4 = 4 Point</li>
                                                <li>5 = 5 Point</li>
                                                <li>6 = 6 Point</li>
                                                <li>Q = 12 Point</li>
                                            </ul>
                                            <div>
                                                <div>
                                                    <div>
                                                        <p class="pt20">PAYOUT</p>
                                                        <table class="table table-bordered table-sm">
                                                            <tbody>
                                                                <tr>
                                                                    <th>Total 0</th>
                                                                    <th>1 to 2.4</th>
                                                                </tr>
                                                                <tr>
                                                                    <th>Total 1</th>
                                                                    <th>1 to 2.09</th>
                                                                </tr>
                                                                <tr>
                                                                    <th>Total 2</th>
                                                                    <th>2.26</th>
                                                                </tr>
                                                                <tr>
                                                                    <th>Total 3</th>
                                                                    <th>1 to 6</th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            )}
        </>
    );
}